import _ from 'lodash';

class LocationHoldsController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService, RouteService, DataCounter, $translate, $location, $q, Modal, BranchService, HoldLocationService,
    $scope, DateUtil, SetupService, $filter, Navigation, UsersService, UserBranchService, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.$scope = $scope
    this.HoldLocationService = HoldLocationService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.sortColumn = "locationId";
    this.reverseSort = true;
    this.allowBulkRelease = true;
    this.moment = moment;
    this.$filter = $filter;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.UserBranchService = UserBranchService;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      lastChecked: null,
      search: null,
      branch: User.getUser().branchId,
      dateRange: {
        startDate: null,
        endDate: null
      },
      includeReleased: false,

      dateRangPickerOptions: {
        autoApply: true,
        maxDate: moment(),
        eventHandlers: {
          'apply.daterangepicker': () => {
            this.loadData();
          }
        },
        ranges: {
          'Today': [
            moment().startOf('day'),
            moment()
          ],
          'Current Week': [
            moment().startOf('week'),
            moment()
          ],
          'Current Month': [
            moment().startOf('month'),
            moment()
          ]
        }
      }
    };
    this.statusList = [
      {
        lable: 'All',
        value: ''
      },
      {
        lable: 'On Hold',
        value: 'ON_HOLD'
      },
      {
        lable: 'Released',
        value: 'RELEASED'
      }
    ];
    this._searchStatus = 'ON_HOLD';

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.locations = [];
    this.branches = [];
    this.currentVaultDate = "";
    this.userDetails = this.User.getUser();
    this.loggedInUser = this.User.getUser().id;
    this.localLang = {
      selectAll: this.$translate.instant('common.selectall'),
      selectNone: this.$translate.instant('common.selectnone'),
      reset: this.$translate.instant('shipmentBatch.reset'),
      search: this.$translate.instant('common.search'),
      nothingSelected: this.$translate.instant('branch.all_branches'),  //default-label is deprecated and replaced with this.
    }
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/location-holds');
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  updateLastChecked() {
    this.model.lastChecked = moment(this.currentVaultDate).format('MM-DD-YYYY');
  }

  refresh() {
    this.loadData();
  }

  pageChange() {
    this.loadData()
  }

  search() {
    this.pagination.page = 1;
    this.loadData()
  }

  generateSearchObj() {
    this.model.search = this.model.search || '';
    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'locationId',
          condition: 'like',
          data: `%${this.model.search}%`
        }],
        operator: 'AND'
      }
    };

    if (this._searchStatus) {
      searchObj.queryJSON.rules.push({
        field: 'status',
        condition: '=',
        data: this._searchStatus
      });
    }
    // if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
    //   searchObj.queryJSON.rules.push({
    //     field: 'holdDate',
    //     condition: '>',
    //     data: this.model.dateRange.startDate.toDate()
    //   });
    //   searchObj.queryJSON.rules.push({
    //     field: 'holdDate',
    //     condition: '<',
    //     data: this.model.dateRange.endDate.toDate()
    //   });
    // }

    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  loadData() {
    setTimeout(() => {
      // const searchObj = this.generateSearchObj();
      this.model.loading = true;
      this.updateLastChecked();

      const branch = this.model.selectedBranch && this.model.selectedBranch.length ? this.model.selectedBranch.map(d => d.branchId).toString() : this.model.branch;

      // return this.HoldLocationService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
      this.HoldLocationService.getHoldLocation(this.model.search, branch, this._searchStatus, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit)
        .then((data) => {
          this.pagination.total = data.total;
          this.pagination.loading = false;
          this.locations = data.results;

          let isOnHold = this.locations.filter((loc) => {
            return loc.status == 'ON_HOLD';
          });

          const obj = { totalRecords: data.total };
          this.$rootScope.$broadcast('setLocationHoldCount', obj);

          this.allowBulkRelease = isOnHold.length ? false : true;
        })
        .catch((err) => {
          // this.error = err.message;
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
          console.log(err);
        })
        .finally(() => {
          this.model.loading = false;
        });
    });
  }

  // release location from Hold
  releaseLocation(heldLocation) {
    if (this.allowOnce) return;
    this.allowOnce = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.locationHoldRelease(heldLocation, !userInfo.supervisor, ({ supervisorId, comment, modal }) => {
          // const { location: { id } } = heldLocation;
          
          this.HoldLocationService.release(userInfo.supervisor ? userInfo.id : supervisorId, heldLocation.locationId, comment, this.model.branch)
            .then((holdLocationData) => {
              this.allowOnce = false;
              const data = this.DataCounter.getCounterForLocationHold();
              this.DataCounter.setCounterForLocationHold(data - 1);
              modal.close();
              this.refresh();
            })
            .catch((err) => {
              this.allowOnce = false;
              const errorCode = err && err.data && err.data.message;
              modal.close();
              if (errorCode) {
                this.Modal.errorModal('error.' + errorCode);
              }
              else {
                console.log(err);
              }
            })
        }, ({ modal }) => {
          this.allowOnce = false;
          if (modal) modal.close();
        })
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  $onInit() {
    // this.model.dateRange.startDate = this.model.dateRangPickerOptions.ranges.Today[0];
    // this.model.dateRange.endDate = this.model.dateRangPickerOptions.ranges.Today[1];
    this.model.dateRange

    this.$q.all([
      this.SetupService.get(this.model.branch),
      this.loadUserBranches()
    ])
      .then((data) => {
        this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
      })
      .then(() => {
        this.loadData();
        this.loadPermission();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  bulkReleased() {
    if (this.isReleased) return;
    this.isReleased = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.locationHoldRelease(false, !userInfo.supervisor, ({ supervisorId, comment, modal }) => {
          this.HoldLocationService.release(userInfo.supervisor ? userInfo.id : supervisorId, null, comment, this.model.branch)
            .then((holdLocationData) => {
              modal.close();
              this.isReleased = false;
              const data = this.DataCounter.getCounterForLocationHold();
              this.DataCounter.setCounterForLocationHold(0);
            })
            .then(() => {
              this.loadData();
              this.isReleased = false;
            })
            .catch((err) => {
              modal.close();
              const errorCode = err && err.data && err.data.message;
              this.isReleased = false;
              if (errorCode) {
                this.Modal.errorModal('error.' + errorCode);
              } else {
                console.log(err);
              }
            });
        }, ({ modal }) => {
          this.isReleased = false;
          if (modal) modal.close();
        })
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  SortData(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
  }

  goToServiceHistory(locationId) {
    this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  loadUserBranches() {
    this.UserBranchService.getUserBranches(this.loggedInUser)
      .then((data) => {
        this.model.userBranchList = data.results;
        this.model.totalBranches = this.model.userBranchList.length;

        this.model.userBranchList.filter((branch) => {
          if (branch.branchId == this.model.branch) {
            branch.ticked = true;
          }
        })
      })
      .catch((err) => {
        console.log(err);
      });
  }

  resetPagination() {
    this.pagination.page = 1;
  }
}

export default LocationHoldsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/location_holds/location_holds.controller.js